import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './utils/DebugTester';
import { isAuthDebugEnabled } from './utils/authDebug';

// Initialize Firebase auth
if (!import.meta.env.VITE_FIREBASE_API_KEY) {
  throw new Error('Add your Firebase configuration to the .env file');
}

// Initialize debug tester in development mode
if (isAuthDebugEnabled()) {
  console.log('🔧 Development mode - Debug tester available');
  console.log('🔧 Available debug commands:');
  console.log('  - testAuth() - Test authentication flow');
  console.log('  - testTokenExpiry() - Test token expiry handling');
  console.log('  - testBackgroundMode() - Test background mode');
  console.log('  - testErrorRecovery() - Test error recovery');
  console.log('  - simulateTokenExpiry() - Simulate token expiry');
  console.log('  - getAuthStats() - Get authentication statistics');
  console.log('  - debugTester.runAllTests() - Run all tests');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
